import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="embedding-start-marker"
//
// Setzt beim Submit die sessionStorage-Marker des ai-embedding-status-
// Controllers (#5102), damit die betroffenen Sektionen nach dem Redirect sofort
// ihren Backfill-Fortschritt pollen. Genutzt vom „Alle Netzwerkinhalte"-Modal
// (#5103): `scopes` enthält "network" plus die IDs der frisch freizuschaltenden
// Gruppen.
export default class extends Controller {
  static values = { scopes: Array };

  connect() {
    this.element.addEventListener("submit", this.mark);
  }

  disconnect() {
    this.element.removeEventListener("submit", this.mark);
  }

  mark = () => {
    try {
      this.scopesValue.forEach((scope) => {
        sessionStorage.setItem(
          `ka-embedding-running:${scope}`,
          JSON.stringify({ group: true, ts: Date.now() }),
        );
      });
    } catch {
      // ohne Marker pollen die Sektionen nach dem Redirect einfach nicht los
    }
  };
}
